<template>
    <div class="nong-contact-box">
        <img class="nong-contact-backer" src="../../assets/image/contact/contact-backer.jpg">
        <div class="nong-contact-div">
            <div class="nong-contact-title">{{ $t('message.contact') }}</div>
            <div class="nong-contact-icon">
<!--                <a href="https://weibo.com/u/6369959192/">-->
<!--                    <img src="../../assets/image/contact/icon-wb.png">-->
<!--                </a>-->
                <a href="url" @click.prevent="overlay = !overlay">
                    <img src="../../assets/image/contact/icon-wx.png">
                </a>
<!--                <a href="https://www.facebook.com/ChasingWang19870704/">-->
<!--                    <img src="../../assets/image/contact/icon-f.png">-->
<!--                </a>-->
                <a href="https://www.instagram.com/nongstudio_shanghai/">
                    <img src="../../assets/image/contact/icon-c.png">
                </a>
<!--                <a  class="nong-contact-icon-h5" href="https://www.pinterest.com/nongstudioshanghai/">-->
<!--                    <img src="../../assets/image/contact/icon-p.png">-->
<!--                </a>-->

            </div>
            <div class="nong-contact-text-box">
                <div class="nong-contact-text-boxs">
                    <span class="nong-contact-text-title">{{getItem=='cn'?data01.name:data01.enName}}</span>
                    <span class="nong-contact-text">{{getItem=='cn'?data01.address:data01.enAddress}} <br/>{{data01.contactWay}}</span>
                    <span class="nong-contact-text-title">{{getItem=='cn'?data02.name:data02.enName}}</span>
                    <span class="nong-contact-text">{{getItem=='cn'?data02.address:data02.enAddress}}
                        <!--                        <br/>{{data02.contactWay}}-->
                    </span>
                    <span class="nong-contact-text-title">{{getItem=='cn'?data03.name:data03.enName}}</span>
                    <span class="nong-contact-text">{{getItem=='cn'?data03.address:data03.enAddress}}
                        <!--                        <br/>{{data01.contactWay}}-->
                    </span>
                </div>
                <div class="nong-contact-text-boxs nong-contact-text-divide">
                    <span class="nong-contact-text-title">{{ $t('message.generalEnquiries') }}</span>
                    <span class="nong-contact-text">17nong@nong-studio.com</span>
<!--                    <span class="nong-contact-text-title">{{ $t('message.marketing') }}</span>-->
<!--                    <span class="nong-contact-text">media@nong-studio.com</span>-->
<!--                    <span class="nong-contact-text-title">{{ $t('message.career') }}</span>-->
<!--                    <span class="nong-contact-text">career@nong-studio.com</span>-->
                </div>
            </div>
        </div>
        <v-overlay :value="overlay">
            <div class="nong-contact-wx-img">
                <img src="../../assets/image/wxerweima.jpg">
            </div>
            <v-btn
                    icon
                    @click="overlay = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
    </div>
</template>

<script>
import {contactList} from "../../api/home";

export default {
  name: "contact",
  data() {
    return {
      overlay: false,
      data01: {},
      data02: {},
      data03: {},
      getItem: 'cn'
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      contactList().then(res => {
        // window.console.log(localStorage.getItem('locale'))
        if (res.errcode == 0) {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].id == 1) {
              this.data01 = res.data[i]
            } else if (res.data[i].id == 2) {
              this.data02 = res.data[i]
            } else {
              this.data03 = res.data[i]
            }
          }
          if (localStorage.getItem('locale') == 'zh-CN') {
            this.getItem = 'cn'
          } else {
            this.getItem = 'en'
          }
          this.news = res.data
        } else {
          window.console.log(res)
        }
      }).catch(err => {
        window.console.log(err)
      });
    }
  }
}
</script>

<style scoped>
    @media screen and (min-width: 960px) {
        .nong-contact-box {
            width: 100%;
            height: 100%;
        }

        .nong-contact-backer {
            width: 100%;
            /*height: 100%;*/
            /*position: absolute;*/
            /*z-index: 0;*/
        }

        .nong-contact-div {
            position: absolute;
            z-index: 1;
            color: white;
            /*bottom:45px;*/
            top: 260px;
            left: 200px;
            display: flex;
            flex-direction: column;
        }

        .nong-contact-title {
            font-size: 25px;
            font-weight: bold;
            line-height: 42px;
            margin-bottom: 25px;
        }

        .nong-contact-icon > a > img {
            width: 16px;
            margin-right: 21px;
        }

        .nong-contact-icon {
            margin-bottom: 80px;
        }

        .nong-contact-text-box {
            width: 500px;
            display: flex;
            flex-direction: row;
        }

        .nong-contact-text-boxs {
            width: 50%;
            display: flex;
            flex-direction: column;
            font-size: 10px;
            line-height: 17px;
            /*font-family: SourceHanSansCN;*/
        }

        .nong-contact-text-title {
            font-weight: bold;
            font-size: 11px;
        }

        .nong-contact-text {
            font-weight: 300;
            margin-bottom: 15px;
            color: #9F9F9F;
        }

        .nong-contact-wx-img {
            width: 200px;
            height: 200px;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;
            border-radius: 5px;
        }

        .nong-contact-wx-img img {
            width: 195px;
            height: 195px;

        }
    }

    @media screen and (max-width: 960px) {
        .nong-contact-box {
            width: 100%;
            height: 100%;
            overflow-y: auto;
        }

        .nong-contact-backer {
            display: none;
        }

        .nong-contact-div {
            color: white;
            /*bottom:45px;*/
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column-reverse;
            width: 100%;
            background: url('../../assets/image/contact/contact-backer-h5.png') no-repeat;
            margin-top: 60px;
            padding-top: 270px;
        }

        .nong-contact-title {
            display: none;
        }

        .nong-contact-icon > a > img {
            width: 28px;
            /*margin-right: 21px;*/
        }

        .nong-contact-icon {
            margin:20px 0 80px 0;
            width: 240px;
            display: flex;
            justify-content: space-around;
        }

        .nong-contact-icon-h5{
            display: none;
        }

        .nong-contact-text-box {
            width: 100%;
            display: flex;
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
        }

        .nong-contact-text-boxs {
            width: 248px;
            display: flex;
            flex-direction: column;
            font-size: 12px;
            line-height: 17px;
            text-align: center;
            padding: 40px 0 20px 0;
            /*font-family: SourceHanSansCN;*/
        }

        .nong-contact-text-title {
            font-weight: bold;
            font-size: 12px;
        }

        .nong-contact-text {
            font-weight: 300;
            margin-bottom: 15px;
            color: #9F9F9F;
        }

        .nong-contact-wx-img {
            width: 200px;
            height: 200px;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;
            border-radius: 5px;
        }

        .nong-contact-wx-img img {
            width: 195px;
            height: 195px;
        }

        .nong-contact-text-divide {
            border-bottom: 1px solid rgba(112, 112, 112, 1);
        }
    }
</style>

<style>
    .v-overlay__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 4;
    }
</style>
